// TODO ZL-856: replace this custom infrastructure with Firebase Remote Config
import { useQuery } from '@tanstack/react-query'
import { doc, getDoc } from 'firebase/firestore'

import { getDbInstance } from '#firebase/runtime'

import { type FeatureFlags, featureFlagsSchema } from './schema'

export const GLOBAL_FEATURE_FLAGS_DOC_ID = 'global'

// Reads feature_flags/global without the doc-wrapper schema (no createdAt/updatedAt
// required) so the document can be created manually in the Firebase Console.
export const useGlobalFeatureFlags = () => {
  return useQuery<FeatureFlags | null>({
    queryKey: ['feature_flags', GLOBAL_FEATURE_FLAGS_DOC_ID],
    queryFn: async (): Promise<FeatureFlags | null> => {
      const snap = await getDoc(
        doc(getDbInstance(), 'feature_flags', GLOBAL_FEATURE_FLAGS_DOC_ID)
      )
      if (!snap.exists()) return null
      return featureFlagsSchema.parse(snap.data())
    },
    retry: false,
  })
}
